<template>
    <div id="tasks">
        <AppBreadCrumb :paths="[{ title: 'Tasks' }]" :select="true" :show-subjects="false"></AppBreadCrumb>
        <div class="route-page-content breadcrumb-content">
            <SidebarChild
                :items="menuItems"
                :selected-item="type"
                :focusActive="true"
                @selected="(i) => (type = i.key)"
                @clicked="fnClicked"
            />
            <div class="page-content-wrapper">
                <div v-if="type === ('kanban' || 'list')" class="head-bar">
                    <div class="batch-operation" v-if="!!batchOperationItems().length">
                        <a-input-group compact>
                            <a-button :value="'test'">
                                <div style="display: flex; align-items: center; gap: 5px">
                                    <a-checkbox
                                        class="kanban-checkbox"
                                        :indeterminate="checkedAllTasks()"
                                        :checked="checkedAllTask"
                                        @change="changeCheckedTasks"
                                    />
                                </div>
                            </a-button>
                            <a-button :value="'test'">
                                <div
                                    style="display: flex; align-items: center; gap: 5px"
                                    @click="changeStageModal = true"
                                >
                                    <div class="material-icons" style="font-size: 20px">table_chart</div>
                                    {{ $t("task.changeStage") }}
                                </div>
                            </a-button>
                            <a-button :value="'xd'">
                                <div
                                    style="display: flex; align-items: center; gap: 5px"
                                    @click="deleteMultipleTasksModal = true"
                                >
                                    <div class="material-icons" style="font-size: 20px">delete</div>
                                    {{ $t("chatbotv2.delete") }}
                                </div>
                            </a-button>
                        </a-input-group>
                    </div>
                    <div v-else>
                        <div class="avatar-content" style="display: flex; align-items: center;">
                            <div v-for="(user, index) in filteredUsersAvatar" :key="user._id" v-if="index < 8">
                                <div @click="toggleUserSelection(user._id)"
                                     :style="{
                                         border: isUserSelected(user._id) ? '2px solid #47499d' : '2px solid white',
                                         borderRadius: '50%',
                                         marginLeft: index !== 0 ? '-10px' : '0px'
                                     }"
                                     class="avatar-container"
                                >
                                    <Avatar
                                        style="cursor: pointer"
                                        :size="30"
                                        :key="1"
                                        :username="user.name"
                                        :src="user.gravatar"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                        }"
                                        :content="user.name"
                                    />
                                </div>
                            </div>
                            <a-popover v-if="filteredUsersAvatar.length > 8" placement="bottom" trigger="click"
                                       style="display:grid; gap:5px">
                                <template #content>
                                    <div v-for="(user, index) in filteredUsersAvatar" :key="user._id" v-if="index >= 8"
                                         style="display: ruby-text; margin-bottom:5px">
                                        <div @click="toggleUserSelection(user._id)"
                                             :style="{
                                                 border: isUserSelected(user._id) ? '2px solid #47499d' : '2px solid white',
                                                 borderRadius: '50%'
                                             }"
                                             class="avatar-container"
                                        >
                                            <Avatar
                                                style="cursor: pointer"
                                                :size="30"
                                                :key="1"
                                                :username="user.name"
                                                :src="user.gravatar"
                                                v-tippy="{
                                                    followCursor: true,
                                                    placement: 'bottom-end',
                                                }"
                                                :content="user.name"
                                            />
                                        </div>
                                        <div
                                            style="cursor: pointer"
                                            @click="toggleUserSelection(user._id)"
                                        >
                                            {{ user.name.length > 20 ? user.name.substring(0, 20) + "..." : user.name }}
                                        </div>
                                    </div>
                                </template>
                                <div
                                    :style="{
                                        border: 'none',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '30px',
                                        height: '30px',
                                        cursor: 'pointer',
                                        backgroundColor: '#47499d',
                                        color: 'white',
                                        fontSize: '14px',
                                        marginLeft: '-10px'
                                    }"
                                    class="avatar-container"
                                >
                                    +{{ filteredUsersAvatar.length - 8 }}
                                </div>
                            </a-popover>
                            <div @click="toggleUserSelection('notAppointed')"
                                 :style="{
                                     border: isUserSelected('notAppointed') ? '2px solid #47499d' : 'none',
                                     borderRadius: '50%',
                                     marginLeft: '-10px'
                                 }"
                                 class="avatar-container"
                            >
                                <Avatar
                                    style="cursor: pointer"
                                    :size="30"
                                    :key="1"
                                    :username="'Atanmadı'"
                                    :src="'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp'"
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                    }"
                                    :content="'Atanmadı'"
                                />
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 10px; cursor:pointer" @click="createTask">
                        <span class="md-icon">add_task</span>
                        <span>Görev Oluştur</span>
                    </div>
                </div>
                <div class="board">
                    <Workflow v-if="type === 'workflowList'" @selected-workflow="changeWorkflow" />
                    <TaskDraggable
                        v-if="workflowId && type === 'kanban'"
                        :workflowId="workflowId"
                        :assignees="assignees"
                    />
                    <KanbanList v-if="type === 'list'" :assignees="assignees" />
                </div>
            </div>
        </div>
        <a-modal
            :visible="deleteMultipleTasksModal"
            icon="exclamation-circle"
            title="Delete Task"
            @cancel="deleteMultipleTasksModal = false"
        >
            <p>{{ $t("task.deleteTaskCont") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteMultipleTasksModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteMultipleTasks">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
        <Modal2
            v-if="changeStageModal"
            @cancel="changeStageModal = false"
            :title="'Change Stage'"
            :description="'1 selected candidate(s)'"
            :ok-text="'Save'"
            @ok="changeTaskPipeline"
        >
            <div class="radio-group-container">
                <a-radio-group v-model:value="selectedPipelineId">
                    <a-radio v-for="pipeline in defaultWorkflow.pipeline" :key="pipeline._id" :value="pipeline._id">
                        {{ pipeline.name }}
                    </a-radio>
                </a-radio-group>
            </div>
        </Modal2>
<!--        <DeleteModal-->
<!--            v-if="deleteWorkflowModal"-->
<!--            :description="$t('task.deleteWorkFlowCont')"-->
<!--            :btnCancelText="$t('message.cancel')"-->
<!--            :btnoktext="$t('message.delete')"-->
<!--            @cancel="deleteWorkflowModal = false"-->
<!--            @confirm="deleteWorkflowFunc"-->
<!--        />-->
    </div>
</template>
<script>
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import { mapActions, mapGetters, mapState } from "vuex";
import KanbanList from "../../../components/task/KanbanList.vue";
import TaskDraggable from "./components/TaskDraggable.vue";
import { getOrUpdateFilters } from "../../../utils/persistenceStorage";
import SupsisButton from "../../../components/common/SupsisButton.vue";
import Modal2 from "../../../components/common/Modal2.vue";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import UsersMenu from "../Team/components/UsersMenu.vue";
import Subjects from "../Team/pages/Subjects.vue";
import Roles from "../Team/pages/Roles.vue";
import ChatBar from "../../../components/ChatBar.vue";
import BannedVisitors from "../Team/pages/BannedVisitors.vue";
import Users from "../Team/pages/Users.vue";
import DeleteModal from "./components/DeleteModal.vue";
import Avatar from "vue-avatar";
import Workflow from "../../../components/task/Workflow.vue";

const filters = getOrUpdateFilters("tasks");
export default {
    components: {
        Users,
        BannedVisitors,
        ChatBar,
        Roles,
        Subjects,
        UsersMenu,
        SidebarChild,
        AppBreadCrumb,
        KanbanList,
        TaskDraggable,
        SupsisButton,
        Modal2,
        DeleteModal,
        Avatar,
        Workflow,
    },
    data() {
        return {
            deleteWorkflowModal: false,
            type: filters.type || "workflowList",
            options: [
                {
                    value: "kanban",
                    label: this.$t("task.kanbanBoard"),
                },
                {
                    value: "list",
                    label: this.$t("task.listView"),
                },
            ],
            workflowId: null,
            assignees: [],
            checkedAllTask: false,
            deleteMultipleTasksModal: false,
            changeStageModal: false,
            selectedPipelineId: null,
            menuItems: [
                {
                    enabled: true,
                    key: "workflowList",
                    label: this.$t("task.workflow"),
                    icon: {
                        type: "material-icons",
                        name: "rebase_edit",
                    },
                },
                {
                    enabled: true,
                    key: "kanban",
                    label: this.$t("task.kanbanBoard"),
                    icon: {
                        type: "material-icons",
                        name: "view_kanban",
                    },
                },
                {
                    enabled: true,
                    key: "list",
                    label: this.$t("task.listView"),
                    icon: {
                        type: "material-icons",
                        name: "list",
                    },
                },
                {
                    enabled: true,
                    key: "workflow",
                    clickEvent: true,
                    label: "Workflow Oluştur",
                    icon: {
                        type: "material-icons",
                        name: "rebase_edit",
                    },
                },
                // {
                //     enabled: true,
                //     key: "addTask",
                //     label: "Görev Oluştur",
                //     clickEvent: true,
                //     icon: {
                //         type: "material-icons",
                //         name: "add_task",
                //     },
                // },
                {
                    enabled: true,
                    key: "settings",
                    label: this.$t("message.settings"),
                    clickEvent: true,
                    icon: {
                        type: "material-icons",
                        name: "settings",
                    },
                },
            ],
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            defaultWorkflow: (state) => state.tasks.defaultWorkflow,
            tasks: (state) => state.tasks.tasks,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            usersAvatar: (state) => state.user.users.data,
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
            checkedItems: (state) => state.tasks.checkedTasks,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        filteredUsersAvatar() {
            const workflowKeys = Object.keys(this.workflows);
            const workflows = workflowKeys.map(key => this.workflows[key]);
            const selectedWorkflows = workflows.filter(workflow => workflow._id === this.workflowId);
            if (selectedWorkflows.length === 0 || selectedWorkflows[0].visibility.users.length === 0) {
                return this.usersAvatar;
            }
            const usersFromSelectedWorkflows = selectedWorkflows.map(workflow => workflow.visibility.users);
            const users = usersFromSelectedWorkflows.flat();
            const usersAvatar = users.map(userId => this.users[userId]);
            return usersAvatar;
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            getTasks: "tasks/getTasks",
            deleteTask: "tasks/deleteTask",
            setCheckedTasks: "tasks/setCheckedTasks",
            multipleTaskDelete: "tasks/multipleTaskDelete",
            mulitpleTaskMove: "tasks/mulitpleTaskMove",
            deleteWorkflow: "tasks/deleteWorkflow",
        }),
        changeWorkflow(id) {
            this.type = "kanban";
            this.workflowId = id;
        },

        getWorkflows() {
            return Object.keys(this.workflows)
                .map((workflow) => this.workflows[workflow])
                .filter((workflow) => {
                    const visibility = workflow.visibility || {};
                    const users = visibility.users || [];
                    const departments = visibility.departments || [];
                    const userSubjects = this.user.subjects || [];
                    const userId = this.user._id || null;
                    if (users.includes(userId) && departments.length === 0) {
                        return true;
                    } else if (departments.some((dept) => userSubjects.includes(dept)) && users.length === 0) {
                        return true;
                    } else if (users.includes(userId) || departments.some(dept => userSubjects.includes(dept))) {
                        return true;
                    } else if (users.length === 0 && departments.length === 0) {
                        return true;
                    }
                    return false;
                })
                .map((workflow) => ({
                    value: workflow._id,
                    label: workflow.title,
                }));
        },
        createWorkflow() {
            this.addNewWindow({
                type: "create-workflow",
            });
        },
        createTask() {
            this.addNewWindow({
                type: "create-task",
            });
        },
        openTaskSettings() {
            this.addNewWindow({
                type: "task-settings",
                footer: false,
            });
        },
        batchOperationItems() {
            return Object.keys(this.checkedItems).filter((key) => this.checkedItems[key]);
        },
        checkedAllTasks() {
            const findOne = Object.values(this.tasks)
                .flat()
                .find((task) => this.checkedItems[task._id]);
            const isNotOne = Object.values(this.tasks)
                .flat()
                .find((task) => !this.checkedItems[task._id]);
            if (!isNotOne) this.checkedAllTask = true;
            return !!(findOne && isNotOne);
        },
        changeCheckedTasks(e) {
            const val = e.target.checked;
            for (const task of Object.values(this.tasks).flat()) {
                this.checkedItems[task._id] = val;
            }
            this.setCheckedTasks({
                ...this.checkedItems,
            });
        },
        deleteMultipleTasks() {
            this.multipleTaskDelete(this.batchOperationItems());
            this.deleteMultipleTasksModal = false;
        },
        changeTaskPipeline() {
            this.mulitpleTaskMove({
                taskIds: Object.keys(this.checkedItems),
                pipelineId: this.selectedPipelineId,
            });
            this.changeStageModal = false;
        },
        openDeleteWorkflowModal(id) {
            this.deleteWorkflowModal = true;
            this.workflowId = id;
        },
        deleteWorkflowFunc() {
            this.deleteWorkflow(this.workflowId);
            this.deleteWorkflowModal = false;

            const workflowKeys = Object.keys(this.workflows);
            const firstWorkflowKey = workflowKeys[0];
            const firstWorkflow = this.workflows[firstWorkflowKey];

            this.workflowId = firstWorkflow._id;
        },
        toggleUserSelection(userId) {
            const index = this.assignees.indexOf(userId);
            if (index > -1) {
                this.assignees.splice(index, 1);
            } else {
                this.assignees.push(userId);
            }
            this.$emit("update:assignees", this.assignees);
        },
        isUserSelected(userId) {
            return this.assignees.includes(userId);
        },
        fnClicked(item) {
            if (item.key === "workflow") {
                this.addNewWindow({
                    type: "create-workflow",
                });
            } else if (item.key === "addTask") {
                this.createTask();
            } else if (item.key === "settings") {
                this.openTaskSettings();
            }
        },
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const workflowParam = urlParams.get("workflow");
        const typeParam = urlParams.get("type");

        if (workflowParam) {
            this.workflowId = workflowParam;
        } else {
            const workflows = this.getWorkflows();
            if (workflows.length > 0) {
                this.workflowId = workflows[0].value;
            }
        }

        if (typeParam) {
            this.type = typeParam;
        }
    },
    beforeDestroy() {
        this.setCheckedTasks({});
    },
    watch: {
        workflowId(newValue) {
            const currentPath = window.location.pathname;
            const queryString = `workflow=${newValue}&type=${this.type}`;
            const newUrl = `${currentPath}?${queryString}`;
            window.history.pushState({ path: newUrl }, "", newUrl);
        },
        type(newValue) {
            getOrUpdateFilters("tasks", {
                type: this.type,
            });

            const currentPath = window.location.pathname;
            const queryString = `workflow=${this.workflowId}&type=${newValue}`;
            const newUrl = `${currentPath}?${queryString}`;
            window.history.pushState({ path: newUrl }, "", newUrl);
        },
    },
};
</script>
<style lang="scss">
$color: #ec4b1d;

#tasks {
    .tasks-wrapper {
        display: flex;
        overflow: hidden;
        position: relative;
        height: calc(100vh - 93px);
    }
    .classic-new-select {
        width: 200px;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
        z-index: 1;
        color: white !important;
        background: #ec4b1d;
        border-color: #ec4b1d;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
        background: #ec4b1d;
    }
    .ant-radio-button-wrapper {
        padding: 0px 40px;
        &:hover {
            color: #ec4b1d;
        }
    }
    .head-bar {
        background-color: var(--color-bg-neutral-default);
        border-bottom: 1px solid var(--color-border-default);
        padding: 0px 24px;
        min-height: 50px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;

        .head-bar-text {
            font-size: 18px;
            font-weight: 500;
            color: #333338;
        }
        .title {
            line-height: 36px;
            color: #333338;
            font-size: 24px;
            font-weight: 400;
            letter-spacing: 0;
        }
    }
    .actions-button {
        display: flex;
        align-items: center;
        justify-content: center;
        .dropdown {
            padding: 10px;
        }
    }
    .more-also {
        &:hover {
            background-color: rgb(226 226 226 / 53%);
            padding: 3px;
            border-radius: 20px;
        }
        &.material-icons {
            padding: 10px;
        }
    }
    .board {
        width: 100%;
        height: calc(100% - 50px);

        .board-content {
            padding: 30px;
        }
        .board-todos {
            display: flex;
            height: 100%;
            .control-panel {
                background-color: white;
                width: 260px;
            }
        }
    }
    .radio-group-container {
        display: grid;
        grid-template-columns: 1fr;
    }

    .avatar-content {
        display: flex;
        align-items: center;
    }

    .avatar-content .avatar {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #444;
        color: white;
        font-size: 12px;
        font-weight: bold;
    }

    .avatar-content .avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .avatar-content .text-avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 12px;
        font-weight: bold;
    }

    .avatar-content .more {
        background-color: #555;
    }
    .avatar-container {
        position: relative;
        transition: transform 0.3s ease;
    }

    .avatar-container:hover {
        transform: scale(1.2);
        z-index: 10;
    }

}
</style>
